import Modal from "react-bootstrap/Modal";
import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import validator from "validator";
import axios from "../../axios";
import { notifyDanger, notifySuccess } from "../../action/customFn";
import { Link } from "react-router-dom";
import {
  RegExpMatcher,
  englishDataset,
  englishRecommendedTransformers,
} from "obscenity";

const BrochureModal = ({ modalShow, setModalShow, program, pdfUrl }) => {
  const [phone, setPhone] = useState("");

  const [formInps, setFormInps] = useState({
    email: "",
    name: "",
    phone_no: "",
  });

  const [country, setCountry] = useState("");

  const [formErrors, setFormErrors] = useState({});

  const errors = {};

  // Initialize the obscenity matcher
  const matcher = new RegExpMatcher({
    ...englishDataset.build(),
    ...englishRecommendedTransformers,
  });

  const handleInpChange = (e) => {
    const { value, name } = e.target;
    setFormInps({ ...formInps, [name]: value });
  };

  const checkForProfanity = (text) => {
    return matcher.hasMatch(text);
  };

  const validation = () => {
    if (formInps.email.length === 0) {
      errors.email = "Please Provide Email!";
    } else if (checkForProfanity(formInps.email)) {
      errors.email = "Please avoid using inappropriate language";
    }
    if (formInps.name.length === 0) {
      errors.name = "Please Provide Name";
    } else if (checkForProfanity(formInps.name)) {
      errors.name = "Please avoid using inappropriate language";
    }
    if (formInps.phone_no.length === 0) {
      errors.phone_no = "Please Provide phone number";
    }
    if (phone.length === 0) {
      errors.phone_code = "Please Provide phone code ";
    }
    if (!validator.isEmail(formInps.email)) {
      errors.email = "Please Provide valid email";
    }
    setFormErrors(errors);
  };

  const handlePhoneChange = (value, countryData) => {
    setPhone(value);
    setCountry(countryData.name);
  };

  const submitData = (e) => {
    e.preventDefault();
    validation();
    if (Object.keys(errors).length === 0) {
      window.open(pdfUrl);
      const data = {
        name: formInps.name,
        email: formInps.email,
        country,
        phone_no: `+${phone} ${formInps.phone_no}`,
        program,
      };

      axios
        .post("/brosureusers", data)
        .then((res) => {
          const { message } = res.data;
          notifySuccess(message);
          setModalShow(false);
        })
        .catch((err) => {
          notifyDanger(err?.response?.message || "Some error Occured");
        });
    }
  };

  return (
    <Modal
      show={modalShow}
      onHide={() => setModalShow(false)}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="program_modal brochure_modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter ">
          <h4 className="text-black"> Brochure Form </h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="brochure_modal_div">
          <form className="brochure_modal_form" onSubmit={submitData}>
            <div className="brochure_form_inp">
              <label>Enter Name</label>
              <input
                placeholder="Enter your name"
                type="text"
                name="name"
                value={formInps.name}
                onChange={handleInpChange}
              />

              {formErrors.name && (
                <div className="form_error_div">{formErrors.name}</div>
              )}
            </div>
            <div className="brochure_form_inp">
              <label>Enter Email </label>
              <input
                placeholder="Enter your email"
                type="email"
                name="email"
                value={formInps.email}
                onChange={handleInpChange}
              />
              {formErrors.email && (
                <div className="form_error_div">{formErrors.email}</div>
              )}
            </div>{" "}
            <div className="brochure_form_inp">
              <label>Enter Phone No. </label>
              <div className="brochure_form_phone">
                <PhoneInput
                  country={"eg"}
                  enableSearch={true}
                  inputClass="form_phone_input"
                  value={phone}
                  onChange={handlePhoneChange}
                />
                <input
                  placeholder="Enter your number"
                  type="number"
                  name="phone_no"
                  value={formInps.phone_no}
                  onChange={handleInpChange}
                />
              </div>
              {formErrors.phone_code && (
                <span className="form_error_div ">{formErrors.phone_code}</span>
              )}
              {formErrors.phone_no && (
                <span className="form_error_div mx-4">
                  {formErrors.phone_no}
                </span>
              )}
            </div>
            <label
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "5px",
                marginTop: "20px",
              }}
            >
              <input
                required
                style={{ width: "16px", height: "16px", marginTop: "4px" }}
                type="checkbox"
              />
              <div>
                <p style={{ margin: "0px" }}>
                  By submitting this form, I agree to MetBrains's{" "}
                  <Link style={{ color: "#2271b1" }} to={"/privacy-policy"}>
                    Privacy Policy
                  </Link>
                </p>
                <p style={{ margin: "0px", fontSize: "12px", color: "gray" }}>
                  Refer to our policy, or contact us for more information.
                </p>
              </div>
            </label>
            <div className="brochure_form_submit">
              <button>Download Brochure</button>
            </div>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BrochureModal;
